var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortimento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96842 7.08L7.6 0L12.2316 7.08H2.96842ZM12.3368 16C11.2982 16 10.4281 15.6667 9.72632 15C9.02456 14.3333 8.67368 13.5067 8.67368 12.52C8.67368 11.5333 9.02456 10.7067 9.72632 10.04C10.4281 9.37333 11.2982 9.04 12.3368 9.04C13.3754 9.04 14.2456 9.37333 14.9474 10.04C15.6491 10.7067 16 11.5333 16 12.52C16 13.5067 15.6491 14.3333 14.9474 15C14.2456 15.6667 13.3754 16 12.3368 16ZM0 15.5V9.42H6.4V15.5H0ZM12.3386 14.8C13.0111 14.8 13.5789 14.5794 14.0421 14.1383C14.5053 13.6972 14.7368 13.1572 14.7368 12.5183C14.7368 11.8794 14.5047 11.34 14.0403 10.9C13.576 10.46 13.0076 10.24 12.3351 10.24C11.6626 10.24 11.0947 10.4606 10.6316 10.9017C10.1684 11.3428 9.93684 11.8828 9.93684 12.5217C9.93684 13.1606 10.169 13.7 10.6333 14.14C11.0977 14.58 11.6661 14.8 12.3386 14.8ZM1.26316 14.3H5.13684V10.62H1.26316V14.3ZM5.24211 5.88H9.9579L7.6 2.26L5.24211 5.88Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortimento);
export default __webpack_public_path__ + "static/media/sortimento.09e7c383.svg";
export { ForwardRef as ReactComponent };